export default {
	'userCancel': 'ユーザーのキャンセル',
	'addrLp': 'LP契約アドレス',
	'bscInLbb': 'BSCはLBBCoinに移行する',
	'goSwap': 'CSwap取引',
	'sumLbb': '累計{0}OC',
	'lookLbb': '契約の表示',
	'addrLbb': 'OC契約アドレス',
	'addrDead': 'ブラックホールアドレス',
	'addrMarket': 'マーケティング住所',
	'ratioTotal': '売上総滑点：10%',
	'ratioLp': 'a.流動性係数：5%',
	'ratioDead': 'b.破壊係数：3%',
	'ratioInv': 'c.招待係数：1%',
	'ratioMarket': 'd.マーケティング係数：1%',
	'contractDesc': '論理フルチェーン実装',
	'contract': '契約',
	'inviteTotal': '全ネットワーク招待奨励金：{0}OC',
	'inviteMy': '私の招待奨励金：{0}OC',
	'lpTotal': 'ネットワーク全体の流動性インセンティブ：{0}OC',
	'lpMy': '私の流動性インセンティブ：{0}OC',
	'lpDesc': 'マイ/フルネット流動性：{0}/{1}LCC',
	'lpAdd': '流動性の追加',
	'lp': 'りゅうどうせい',
	'invSell': '最大1%招待奨励金',
	'lpSell': '流動性加重インセンティブを持つ1件当たりの売上高の5%',
	'myInvites': '私の招待',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': '私の推薦人',
	'invite': '招待',
	'inviteNotice1': '相手に0.1 OCを送信',
	'inviteNotice2': '相手が確認したら、招待が成功します',
	'inviteBind': '推薦者をバインドしてください',
	'chainConfirm': '上鎖中・・・',
	'{0} Operate Fast': 'あまりにも頻繁に操作されているので、秒後に続行してください',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': '確認',
	'Osnft Detail': '詳細を見る',
	'{0} Not Enogugh': 'あなたの{0}が不足しています',
	'Operate Success': '操作に成功しました',
	'zlang143': 'コピー成功',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'ocLockTitle': 'OCロック',
	'ocLockDeposit': '預入',
	'ocLockActive': 'Status',
	'ocLockReleased': '解放済み',
	'ocLockClaim': '出金',
	'themeNeon': 'ネオンブルー',
	'themeIce': 'アイス回路',
	'themeViolet': 'バイオレットゴールド',
	'themeAurora': 'オーロラミント',
	'themeEmber': 'エンバーナイト',
	'themeMono': 'ディープモノ',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
}
